/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Action_TypeInputs */

const cs_automation_action_type = /** @type {(inputs: Automation_Action_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ akce`)
};

const en_automation_action_type = /** @type {(inputs: Automation_Action_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action type`)
};

/**
* | output |
* | --- |
* | "Action type" |
*
* @param {Automation_Action_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_action_type = /** @type {((inputs?: Automation_Action_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Action_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_action_type(inputs)
	return cs_automation_action_type(inputs)
});